import LightP1 from '@/domain/scene/lights/platform/LightP1.js'
import LightP2 from '@/domain/scene/lights/platform/LightP2.js'
import LightP3 from '@/domain/scene/lights/platform/LightP3.js'
import LightP4 from '@/domain/scene/lights/platform/LightP4.js'
import LightP5 from '@/domain/scene/lights/platform/LightP5.js'

import LightT1 from '@/domain/scene/lights/train/LightT1.js'
import LightT2 from '@/domain/scene/lights/train/LightT2.js'
import LightT3 from '@/domain/scene/lights/train/LightT3.js'
import LightT4 from '@/domain/scene/lights/train/LightT4.js'
import LightT5 from '@/domain/scene/lights/train/LightT5.js'

export default class Lights {
  constructor () {
    this.light_p1 = new LightP1()
    this.light_p2 = new LightP2()
    this.light_p3 = new LightP3()
    this.light_p4 = new LightP4()
    this.light_p5 = new LightP5()

    this.light_t1 = new LightT1()
    this.light_t2 = new LightT2()
    this.light_t3 = new LightT3()
    this.light_t4 = new LightT4()
    this.light_t5 = new LightT5()
  }

  setOnScene (sceneWidth, sceneHeight, isInTrain, speedC, sceneImages) {
    if (isInTrain) {
      this.light_p1.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.light_p2.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.light_p3.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.light_p4.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.light_p5.setOnScene(sceneWidth, sceneHeight, speedC, '')

      this.light_t1.setOnScene(sceneWidth, sceneHeight, null, '')
      this.light_t2.setOnScene(sceneWidth, sceneHeight, null, '')
      this.light_t3.setOnScene(sceneWidth, sceneHeight, null, '')
      this.light_t4.setOnScene(sceneWidth, sceneHeight, null, '')
      this.light_t5.setOnScene(sceneWidth, sceneHeight, null, '')
    } else {
      this.light_p1.setOnScene(sceneWidth, sceneHeight, null, '')
      this.light_p2.setOnScene(sceneWidth, sceneHeight, null, '')
      this.light_p3.setOnScene(sceneWidth, sceneHeight, null, '')
      this.light_p4.setOnScene(sceneWidth, sceneHeight, null, '')
      this.light_p5.setOnScene(sceneWidth, sceneHeight, null, '')

      this.light_t1.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.light_t2.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.light_t3.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.light_t4.setOnScene(sceneWidth, sceneHeight, speedC, '')
      this.light_t5.setOnScene(sceneWidth, sceneHeight, speedC, '')
    }

    this.light_p1.setImage(sceneImages['platformLight']['image'])
    this.light_p2.setImage(sceneImages['platformLight']['image'])
    this.light_p3.setImage(sceneImages['platformLight']['image'])
    this.light_p4.setImage(sceneImages['platformLight']['image'])
    this.light_p5.setImage(sceneImages['platformLight']['image'])

    this.light_t1.setImage(sceneImages['trainLight']['image'])
    this.light_t2.setImage(sceneImages['trainLight']['image'])
    this.light_t3.setImage(sceneImages['trainLight']['image'])
    this.light_t4.setImage(sceneImages['trainLight']['image'])
    this.light_t5.setImage(sceneImages['trainLightLocomotive']['image'])
  }

  setValues (lightsEnabled, isObserverInTrain, observerPosM, oppositeObjPosM, isRelativistic, speedValue) {
    this.light_p1.setValue(lightsEnabled, isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.light_p2.setValue(lightsEnabled, isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.light_p3.setValue(lightsEnabled, isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.light_p4.setValue(lightsEnabled, isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.light_p5.setValue(lightsEnabled, isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)

    this.light_t1.setValue(lightsEnabled, isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.light_t2.setValue(lightsEnabled, isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.light_t3.setValue(lightsEnabled, isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.light_t4.setValue(lightsEnabled, isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
    this.light_t5.setValue(lightsEnabled, isObserverInTrain, oppositeObjPosM, isRelativistic, speedValue)
  }
}
